// extracted by mini-css-extract-plugin
export default {"form":"aqTrj","inner":"nQxSj","actions":"R5xy1","action":"B1HlI","section":"Sfy2H","sectionInner":"zYQ8B","sectionInnerEmpty":"YsJs2","emptyState":"WbClv"};